import { ReactNode, SyntheticEvent, useState } from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import CompanyProfile from "./CompanyProfile";
import MtExportSettings from "./MtExport";
import { POLICY_SETTINGS_TABS } from "./PolicySettings/tabs";

interface SystemSettingsTab {
  label: string;
  component: ReactNode;
}

/** One tab per settings area; each area lives in its own subfolder. */
const SYSTEM_SETTINGS_TABS: SystemSettingsTab[] = [
  { label: "ข้อมูลบริษัท", component: <CompanyProfile /> },
  { label: "ตั้งค่า export เชน MT", component: <MtExportSettings /> },
  ...POLICY_SETTINGS_TABS,
];

const FIRST_TAB_INDEX = 0;

/** ตั้งค่าระบบ (MASTER): one tab per settings area, only the active one mounted. */
export default function SystemSettings() {
  const [activeIndex, setActiveIndex] = useState<number>(FIRST_TAB_INDEX);
  const activeTab = SYSTEM_SETTINGS_TABS[activeIndex];

  const handleChangeTab = (_event: SyntheticEvent, index: number) => setActiveIndex(index);

  return (
    <Stack spacing={2}>
      <Tabs
        value={activeIndex}
        onChange={handleChangeTab}
        variant="scrollable"
        scrollButtons="auto"
      >
        {SYSTEM_SETTINGS_TABS.map((tab) => (
          <Tab key={tab.label} label={tab.label} />
        ))}
      </Tabs>
      {/* Keyed so every switch remounts the tab and it reloads what it shows. */}
      <Box key={activeTab.label}>{activeTab.component}</Box>
    </Stack>
  );
}
